<template>
  <div
    class="f-column radio-button-box"
    v-validate="errors"
  >
    <div class="radio-button-box-gray mb-children-1 mr-children-1 mr-children-0-768 f-column-768">
      <button
        class="width-6-768 width-minus-tooltip-600"
        v-for="(option, index) in options"
        tabindex="-1"
        :key="index + 1"
        :class="{'radio-selected': value && option.name$ === value.name$}"
        :style="option.disabled ? { opacity: 0.75, pointerEvents: 'none' }: {}"
        @click.prevent="$emit('input', option)"
      >{{option.label}}</button>
    </div>
    <div class="validation-output">
      <slot name="validations"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioBox',
  props: {
    value: { required: false, validator: (v) => !v || typeof v === 'object' },
    options: { required: true, type: Array },
    errors: { required: false, type: Array, default: () => [] },
  },
};
</script>
